export const setConfig = (payload) => {
  return {
    type: 'SET_CONFIG',
    config: payload,
  };
};
